import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar, FaSwimmingPool, FaHandSparkles } from "react-icons/fa";
import { IoCalendarOutline, IoFastFoodOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { CgGym } from "react-icons/cg";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useRef, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { MenuContext } from "../context/MenuContext";
import { IoMdArrowRoundBack } from "react-icons/io";
import { TostMessageContext } from "../context/TostMessage";
import { useReactToPrint } from "react-to-print";
import club_logo from '../images/riverrun.png'
import { CancelBookingModal } from "../components/cancel_booking";

export default function ReservationSuccess() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [apartmentList, setApartmentList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const {state} = useLocation();
    const [pageData, setPageData] = useState({});
    const [initialised, setInitialised] = useState(false);
    const { apt, rrr } = useParams();
    const {menuOpen, setMenuOpen} = useContext(MenuContext)
    const {setTostMessage} = useContext(TostMessageContext)
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [apartmentReview, setApartmentReview] = useState({});

    const componentRef = useRef();

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });

    useEffect(() => {
      if (menuOpen) setMenuOpen(false);
      setFormFields({...formFields, apt, rrr  });
      setInitialised(true); // flag
    }, [])

    useEffect(() => {
        if (!initialised) return;   // ❌ ignore all other updates
        if (!formFields.apt) return;

        getData();                  // ✅ runs ONLY once
        setInitialised(false);      // stop it from ever running again
    }, [formFields, initialised]);

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/reservation-success.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
                setPageData({...pageData, ...response.data })
            } else {

            }
        } catch (error) {
          setPageLoading(false)
        }
    }

    async function cancelReservation() {
        if (window.confirm("Are you sure you want to cancel this reservation?")) {
            const formData = new FormData();
            formData.append('rrr', rrr);
            setPageLoading(true)
            try {
                const response = await axios.post(base_url + '/cancel-booking.php', formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        token: cookies?.userProfile?.session,
                        accountid: cookies?.userProfile?.main_id,
                    },
                });
                if (response.data.code == 403) {
                    logOutFunction()
                }
                setPageLoading(false)
                if (response.data.status) {
                    setTostMessage({
                        messageType: 'success',
                        message: response.data.message
                    })
                    navigate(-1);
                } else {
                    setTostMessage({
                        messageType: 'success',
                        message: response.data.message
                    })
                }
            } catch (error) {
                setPageLoading(false)
                setTostMessage({
                    messageType: 'success',
                    message: "Network Error"
                })
            }
        }
    }

    const copyText = (review_link) => {
        navigator.clipboard.writeText(review_link)
        .then(() => setTostMessage({ 
            messageType: 'success',
            message: 'Review link copied to clipboard'
        }))
        .catch(err => setTostMessage({ 
            messageType: 'error',
            message: 'Unable to generate review link right now'
        }));
    };

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {showReviewModal && (
            <CancelBookingModal
                setShowReviewModal={setShowReviewModal}
                setApartmentReview={setApartmentReview}
                apartmentReview={apartmentReview}
            />
        )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
        <div className="animate-fadeIn py-6 px-10 flex flex-col justify-start">
            <div className="flex items-center justify-between">
                <div className="flex items-center justify-start gap-x-3">
                    <button onClick={() => navigate(-1)} className="p-2 border border-2 rounded-full"><IoMdArrowRoundBack size={20} /></button>
                    <h2 className="text-2xl text-black font-bold">{pageData?.apt_name}</h2>
                </div>
                
                    <div className="flex flex-row gap-x-2">
                        <button onClick={() => copyText(pageData?.review_link)} className="bg-secondary hover:bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                            <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Share Review Link</span>
                        </button>
                        <button onClick={handlePrint} className="bg-secondary hover:bg-primary text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                            <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Print Receipt</span>
                        </button>
                        {pageData?.reservation_success &&
                        <button onClick={() => {setShowReviewModal(true); setApartmentReview({ rrr })} } className="bg-[#ff0000] text-white flex flex-row items-center justify-evenly w-auto h-[35px] px-5 rounded-xl shadow-md shrink-0 text-sm md:text-md font-cormorant-bold">
                            <span className="text-white font-cormorant-bold text-sm md:text-md update-price">Cancel Booking</span>
                        </button>
                        }
                    </div>
                
            </div>
            <div ref={componentRef} className={`px-5`}>
                <div className='flex flex-col justify-center items-center w-full my-[20px]'>
                    <img src={club_logo} className="h-auto w-[75px] mx-auto" alt="logo" />
                </div>
                <div className="flex items-center justify-center gap-3 md:gap-10 mb-5 mt-5">
                    <div className="flex flex-col text-center items-center">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center">1</div>
                    <p className="text-sm mt-1 text-black font-aileron-regular">{pageData?.apt_name}</p>
                    </div>
                
                    <div className="border-t border-gray-300 w-10 md:w-24"></div>
                
                    <div className="flex flex-col text-center items-center">
                    <div className="w-8 h-8 rounded-full bg-gray-300 text-black flex items-center justify-center">2</div>
                    <p className="text-sm mt-1 text-black font-aileron-regular">BOOKING DETAILS</p>
                    </div>
                
                    <div className="border-t border-gray-300 w-10 md:w-24"></div>
                
                    <div className="flex flex-col text-center items-center">
                    <div className="w-8 h-8 rounded-full text-white bg-primary flex items-center justify-center">3</div>
                    <p className="text-sm mt-1 text-black font-aileron-regular">FINISH BOOKING</p>
                    </div>
                </div>
                {pageData?.reservation_success ? 
                    <div className="w-[fit-content] mx-auto py-3 px-6 border border-1 rounded-[10px] bg-[#1d8c4f] text-center mb-4">
                        <p className="font-semibold font-aileron-regular text-white">Yayyy! Your reservation is confirmed</p>
                    </div>
                    :
                    <div className="w-[fit-content] mx-auto py-3 px-6 border border-1 rounded-[10px] bg-[#ff0000] text-center mb-4">
                        <p className="font-aileron-regular font-semibold text-[#ffffff]">This booking has been cancelled</p>
                    </div>
                }

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                
                    <div className="lg:col-span-2 space-y-10">
                
                    <div>
                        <div className="flex items-start justify-between">
                        <div>
                            <p className="font-semibold font-aileron-regular">Your trip</p>
                            <p className="text-sm text-black mt-2">
                            <span className="font-semibold font-aileron-regular">Dates</span><br/>
                            {pageData?.booking_dates_summary}
                            </p>
                            <p className="text-sm text-black mt-4">
                            <span className="font-semibold font-aileron-regular">Duration</span><br/>
                            {pageData?.duration} Night(s)
                            </p>
                        </div>

                        </div>
                    </div>
                
                    <div>
                        <h2 className="text-md font-semibold font-aileron-regular">Main Guest Info</h2>
                        <p className="text-sm text-black mt-1">Guest name must match the valid ID used at check-in.</p>
                
                        <div className="grid sm:grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="text-sm font-aileron-regular">First Name</label>
                            <input 
                            value={pageData?.first_name}
                            readOnly
                            className="first_name mt-1 w-full p-2 border rounded-lg" placeholder="Emmily" />
                        </div>
                
                        <div>
                            <label className="text-sm font-aileron-regular">Last Name</label>
                            <input 
                            value={pageData?.last_name}
                            readOnly
                            className="last_name mt-1 w-full p-2 border rounded-lg" placeholder="Morgan" />
                        </div>
                        </div>
                
                        <div className="grid sm:grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="text-sm font-aileron-regular">Email Address</label>
                            <input 
                            value={pageData?.email}
                            readOnly
                            className="email mt-1 w-full p-2 border rounded-lg" placeholder="email@example.com" />
                        </div>
                
                        <div>
                            <label className="text-sm font-aileron-regular">Phone Number</label>
                            <input 
                            value={pageData?.phone_number}
                            readOnly
                            className="phone_number mt-1 w-full p-2 border rounded-lg" placeholder="(+234) 000 000 000" />
                        </div>
                        </div>
                    </div>
                
                    <div>
                        <h2 className="text-md  font-semiboldfont-aileron-regular">Special Requests <span className="text-black text-sm">(optional)</span></h2>
                        <p className="text-sm text-black mt-1">The property will do its best, but cannot guarantee to fulfil all requests.</p>
                
                        <textarea
                        name="special_requests"
                        value={pageData?.special_requests}
                        readOnly
                        className="w-full mt-4 h-32 p-3 border rounded-lg"
                        placeholder="Let us know if there's anything we can assist you with."
                        ></textarea>
                    </div>

                    {!pageData?.reservation_success &&
                        <div>
                            <h2 className="text-md  font-semiboldfont-aileron-regular">Cancelled at {pageData?.cancellation?.time}</h2>
                    
                            <textarea
                            name="special_requests"
                            value={pageData?.cancellation?.reason}
                            readOnly
                            className="w-full mt-4 h-32 p-3 border rounded-lg"
                            placeholder="Let us know if there's anything we can assist you with."
                            ></textarea>
                        </div>
                    }
                
                    {/* <div className="border-t pt-6">
                        <p className="font-aileron-regular text-sm">
                        <span className="text-blue-600 font-aileron-regular text-[lg]">Free cancellation before {pageData?.max_cancellation_date}.</span>
                        </p>
                        <button className="text-sm text-blue-600 mt-2">Learn more</button>
                    </div> */}
                
                    </div>
                
                <div className="sticky top-10 h-[min-content] animate-scaleIn">
                        <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
                    
                            <div className="border rounded-lg p-4 text-sm">
                            <div className="flex justify-between">
                                <div>
                                <p className="text-black font-semibold">Check-in</p>
                                <p className="font-aileron-regular">{pageData.check_in}</p>
                                </div>
                                <div>
                                <p className="text-black font-semibold">Check-out</p>
                                <p className="font-aileron-regular">{pageData.check_out}</p>
                                </div>
                            </div>
                            </div>
                    
                            <div className="text-sm space-y-2">
                                <div class="flex flex-col justify-between gap-y-1 mb-1">
                                    <p class="font-cormorant-semibold mb-1">Your Bookings</p>
                                    <div class="flex flex-col">
                                        {pageData?.bookings_arr?.map((apartment, index) =>
                                            <div class="flex flex-col"> 
                                                <p class="font-semibold font-aileron-regular text-md">{apartment?.quantity}{'x '}{apartment?.apt_cat}</p>
                                                <p class="font-semibold font-aileron-regular text-md">{apartment?.pricing_plan}</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="flex flex-col justify-start addon_list">
                                    {pageData?.booking_addons?.map((service, index) => {
                                        return (
                                            <p key={index} className="font-aileron-regular mt-1">{service.service_name}</p>
                                        )
                                    })}
                                </div>
                                <div className="flex justify-between">
                                    <p className="font-semibold">Booking Amount</p>
                                    <p className="font-aileron-regular">{pageData?.booking_amount}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="font-semibold">Taxes</p>
                                    <p className="font-aileron-regular">{pageData?.taxes}</p>
                                </div>
                                <div className="flex justify-between">
                                    <p className="font-semibold">Refundable Deposit</p>
                                    <p className="font-aileron-regular">{pageData?.refundable_deposit}</p>
                                </div>
                                {pageData?.free_cancellation == "YES" && <div className="flex justify-between">
                                        <p>Free cancellation fee</p>
                                        <p className="font-aileron-regular">{pageData?.free_cancellation_amount}</p>
                                    </div>
                                }
                            </div>
                    
                            <div className="flex justify-between font-aileron-regular text-lg border-t pt-4">
                            <p className="font-bold">Total</p>
                            <p className="font-bold font-aileron-regular">{pageData?.total_amount}</p>
                            </div>
                        </div>
                    </div>
            </div>
        </div>
    </div>
    </div>
  );
}
